<template>
  <div class="mt-1">
    <div v-for="(item, years_interval) in params['history']" :class="item.opened ? 'opened' : ''" class="history mt-1">
		<div v-on:click="item.opened = !item.opened">
			<h6 class="section-title d-inline-block align-top cursor-pointer" >
				{{years_interval}}
			</h6>
			<h6 class="section-title ml-md-2 ml-1 d-inline-block align-top cursor-pointer">
				<i class="rotate-icon font-size-16 font-size-md-16 mt-0 fa fa-sort-down d-inline-block align-top"></i>
			</h6>
		</div>
		<div class="ani-height-container" :class="(isIE) ? 'no_animate' : ''" :style="'max-height: ' +((item.opened) ? item.height : 0) +'px;'">
			<div class="container">
				<b-row>
					<b-col class="p-0">
						<div v-html="item.content" class="mb-4"></div>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
  </div>
</template>
<script>
export default {
  name: 'history',
  props: ['params'],
}
</script>
<style scoped>
.history .rotate-icon {
	overflow: hidden;
	transition: all 0.3s ease-in-out;
	transform: rotate(-90deg);
    -webkit-transform: rotate(-90deg);
}
.history.opened .rotate-icon {
	transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
	/*font-size: 22px;*/
}
.ani-height-container {
	max-height: 0;
    transition: max-height 0.4s ease-in-out;
    overflow: hidden;
}
.no_animate.ani-height-container {
	transition: all 0s ease-in-out;
}
</style>